import Logo from './Logo';

// Shared shell nav for both school-admin and super-admin — only the accent
// (`tier`) and the item list differ between the two surfaces. An item of the
// form { section: 'Label' } renders as a group heading instead of a button.
export default function Sidebar({ items, active, onSelect, tier = 'transit' }) {
  const activeBorder = tier === 'clearance' ? 'shadow-[inset_3px_0_0_var(--clearance)]' : 'shadow-[inset_3px_0_0_var(--transit)]';

  return (
    <nav className="bg-[#101b22] text-[#cdd8d6] w-[224px] shrink-0 flex flex-col gap-1 p-3.5 overflow-y-auto">
      <div className="px-2 pb-4 pt-1">
        <Logo tier={tier} size={30} />
      </div>
      {items.map(item => item.section ? (
        <div key={`section-${item.section}`}
          className="px-3 pt-3 pb-1 text-[10.5px] font-bold uppercase tracking-[0.12em] text-[#6f8580]">
          {item.section}
        </div>
      ) : (
        <button
          key={item.key}
          onClick={() => onSelect(item.key)}
          className={`flex items-center gap-2.5 px-3 py-2.5 rounded-s text-[13.5px] font-body font-semibold text-left transition-colors
            ${active === item.key
              ? `bg-white/10 text-white ${activeBorder}`
              : 'text-[#9db1ac] hover:bg-white/5 hover:text-white'}`}
        >
          {item.icon && <item.icon size={16} className="opacity-90 shrink-0" />}
          <span className="truncate">{item.label}</span>
          {item.badge > 0 && (
            <span className="ml-auto text-[11px] font-bold bg-critical text-white rounded-full px-1.5 min-w-[20px] text-center tabular-nums">
              {item.badge}
            </span>
          )}
        </button>
      ))}
    </nav>
  );
}
